import { Button } from '@workspace/ui/components/button';
import { ArrowRight, Terminal } from 'lucide-react';
import { useEffect } from 'react';
import { CliCommandWidget } from '~/components/cli-command-widget';
import { m } from '~/paraglide/messages.js';
import { CLI_AUTH_SUCCESS_KEY } from '../../cli/-config/permissions';

type Props = {
  onNext: () => void;
};

export function ConnectBloqueComponent({ onNext }: Props) {
  useEffect(() => {
    const handler = (e: StorageEvent) => {
      if (e.key === CLI_AUTH_SUCCESS_KEY) {
        localStorage.removeItem(CLI_AUTH_SUCCESS_KEY);
        onNext();
      }
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, [onNext]);

  return (
    <div className="w-full max-w-md space-y-8">
      <div className="flex items-center justify-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10">
          <Terminal className="h-8 w-8 text-primary" />
        </div>
      </div>

      <div className="space-y-3 text-center">
        <p className="text-sm text-muted-foreground">
          {m['onboarding.connect_bloque.description']()}
        </p>
      </div>

      <CliCommandWidget />

      <div className="space-y-3">
        <Button
          onClick={onNext}
          className="flex w-full items-center justify-center gap-2 py-6 font-semibold transition-all"
        >
          {m['common.continue']()}
          <ArrowRight className="h-5 w-5" />
        </Button>

        <button
          type="button"
          onClick={onNext}
          className="w-full py-2 text-center text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          {m['onboarding.connect_bloque.skip']()}
        </button>
      </div>
    </div>
  );
}
